import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceLand from "@/views/审核管理/service/DZServiceLand";
import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchLand from "@/views/审核管理/model/search/DZSearchLand";
import DZModelDicConfig from "@/model/DZModelDicConfig";

@Component({
    components: {}
})
export default class Index extends Vue {

    toPrint(){
        this.$nyPrint.printTable(this.selections,this.json_fields,this.excelName)
    }

    json_fields = {
        '土地名称':'title',
        '价格':'priceInfo',
        '面积':'areaInfo',
        '年限':'usefulYear',
        '地区':'region',
        '联系人':'contactsInfo',
        '土地类型':'type',
        '流转类型':'moverTypeName',
        '发布状态':'status',
        '发布时间':'createTime'
    }
    excelName = '土地列表.xls'
    selections = []
    handleSelectionChange(val) {
        val.map(v=>{
            v.type = this.bindType(v.type)
            v.status = this.bindStatus(v.status)
        })
        this.selections = val;
    }

    $refs: any;

    table_height = 0;

    serve = new DZServiceLand();

    dic_config = new DZModelDicConfig();

    /** 流转类型 **/
    list_moverType : Array<string> = []
    /** 土地标签 **/
    list_landLabel : Array<string> = []

    created() {
        this.action_page_land()
        this.action_list_moverType()
        this.action_list_landLabel()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }
    handle_edit(id){
        this.$router.push({ path: "/land/info", query: { id: id , sign: "review" } })
    }

    handle_review(id){
        this.$router.push({ path: "/land/reviewInfo", query: { id: id } })
    }

    action_page_land(){
        let arr = this.serve.m_search.countyArr
        if(arr.length != 0){
            this.serve.m_search.county = arr[2]
        }
        this.serve.net_page_land()
    }

    el_cascader_props = {
        lazy: true,
        lazyLoad (node, resolve) {
            const { level,value } = node;
            let id = 0
            if(level != 0){
                id = value
            }
            nyNetwork.net("城市列表",{pid:id}, data => {
                const nodes = data.map(i=>{
                    return {
                        value:i.id,
                        label:i.name,
                        leaf:level>=2
                    }
                })
                resolve(nodes)
            })
        }
    }

    // 1-农业用地 2-建设用地
    bindType(val){
        if(val == 1){
            return "农业用地"
        }else if(val == 2){
            return "建设用地"
        }else {
            return val
        }
    }

    //发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
    bindStatus(status){
        switch (status){
            case 0: return "待审核";
            case 1: return "待交易";
            case 2: return "审核未通过";
            case 3: return "暂停发布";
            case 4: return "已过期";
            case 5: return "已交易";
            default :return status
        }
    }

    action_list_moverType(){
        nyNetwork.get("字典列表查询", {id:this.dic_config.get("流转类型")}, data => {
            this.list_moverType = data
        })
    }

    action_list_landLabel(){
        nyNetwork.get("字典列表查询", {id:this.dic_config.get("土地标签")}, data => {
            this.list_landLabel = data
        })
    }

    clean(){
        this.serve.m_search = new DZSearchLand(10);
        this.action_page_land()
    }

    // 操作 a-通过 b-拒绝 c-暂停 d-继续
    handleCommand(id,event){
        switch (event){
            case "a":
                this.serve.net_land_pass(id,this.action_page_land)
                return
            case "b":
                this.serve.net_land_refuse(id,this.action_page_land)
                return
            case "c":
                this.serve.net_land_operate(id,this.action_page_land)
                return
            case "d":
                this.serve.net_land_operate(id,this.action_page_land)
                return
            default:return;
        }
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit(row.id)
        }
    }

    handleSizeChange(val){
        this.serve.m_search.pageSize = val
        this.action_page_land()
    }
}
